// Ranges per https://help.trustpilot.com/s/article/TrustScore-and-star-rating-explained
export function getRatingLabel(score: number): string {
  if (score >= 4.3) return "Excellent";
  if (score >= 3.8) return "Great";
  if (score >= 2.8) return "Average";
  if (score >= 1.8) return "Poor";
  return "Bad";
}
